import { CampaignWorkflowFormAction, CampaignWorkflowFormState } from './CampaignWorkflowFormState';

export const CampaignWorkflowFormReducer = (state: CampaignWorkflowFormState, action: CampaignWorkflowFormAction) => {
  switch (action.type) {
    case 'SET_TOUCHED': {
      return {
        ...state,
        touched: {
          ...state.touched,
          [action.payload.key]: action.payload.isTouched,
        },
      };
    }
    case 'SET_FOCUSED': {
      return {
        ...state,
        focused: {
          ...state.focused,
          [action.payload.key]: action.payload.isFocused,
        },
        touched: {
          ...state.touched,
          [action.payload.key]: true,
        },
      };
    }
    case 'SET_ERROR': {
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.key]: action.payload.hasError,
        },
      };
    }
    case 'SET_ERRORS': {
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.payload.errors,
        },
      };
    }
    case 'SET_VALIDATION_RESULTS': {
      return {
        ...state,
        validationResults: action.payload,
        validationType: action.validationType,
      };
    }
    default:
      return state;
  }
};
